import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, { FormBody, FormActions, TextInput } from '../../../Form';

@inject('imageTagStore')
@observer
class ImageTagAdd extends Component {
  static propTypes = {
    route: PropTypes.shape().isRequired,
    imageTagStore: PropTypes.object.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  }

  @observable item = {
    name: '',
    description: '',
  };

  slug = '/idaq/image-tag';
  title = 'Add Image Tag';

  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);
  }

  @action onChangeName = (e) => { this.item.name = e.target.value; }
  @action onChangeDescription = (e) => { this.item.description = e.target.value; }

  handleSave(e) {
    const { notify } = this.context;

    e.preventDefault();

    const { imageTagStore } = this.props;
    imageTagStore.createItem(this.item)
        .then(() => {
          notify.success();
          this.context.router.push(this.slug);
        })
        .catch(err => { notify.error(err); });
  }

  render() {
    const { imageTagStore } = this.props;

    if (imageTagStore.isLoading) { return <Spinner />; }

    return (
        <Modal title={this.title} slug={this.slug} isSaving={imageTagStore.isSaving} handleSave={this.handleSave}>
          <Form>
            <FormBody>
              <TextInput label={'Name'} value={this.item.name} onChange={this.onChangeName} />
              <TextInput label={'Description'} value={this.item.description} onChange={this.onChangeDescription} />
            </FormBody>

            <FormActions>
              <button onClick={this.handleSave}>Save</button>
            </FormActions>
          </Form>
        </Modal>
    );
  }
}

export default ImageTagAdd;



// WEBPACK FOOTER //
// ./src/components/IDaq/ImageTags/pages/ImageTagAdd.js